'use client'

import { useAppDispatch } from '@/lib/hooks'
import { setCart as setCartAction } from '@/lib/redux'
import { toast } from 'sonner'

interface ApplyPaymentMethodDiscountPayload {
  cartId: string
  paymentMethodId: number | string
  payableAmount?: number | null
}

export const usePaymentMethodDiscount = () => {
  const dispatch = useAppDispatch()

  const applyPaymentMethodDiscount = (
    payload: ApplyPaymentMethodDiscountPayload,
  ) => {
    return new Promise((resolve, reject) => {
      const worker = new Worker(
        new URL('@/lib/workers/payment-discount.worker', import.meta.url),
      )

      worker.postMessage({
        type: 'APPLY_PAYMENT_METHOD_DISCOUNT',
        payload,
      })

      worker.onmessage = (event) => {
        const { type, error, data } = event.data

        console.log({event});
        

        if (type === 'ERROR') {
          toast.error(error || 'Failed to apply discount')
          worker.terminate()
          reject(error)
          return
        }

        if (type === 'SUCCESS') {
          dispatch(setCartAction(data))
          worker.terminate()
          resolve(data)
        }
      }

      worker.onerror = (error) => {
        console.error('Worker error:', error)
        toast.error('An error occurred while applying discount')
        worker.terminate()
        reject(error)
      }
    })
  }

  return {
    applyPaymentMethodDiscount,
  }
}
